import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiTravelMemberHelperService } from './travel-member-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiTravelMessagingService {
  constructor(
    public hpr: ApiTravelMemberHelperService,
    private _api: ApiService,
  ) {}

  getDiscussion(data: any = {}) {
    return this._api.post('travel-messaging/get-discussion', data);
  }

  listDiscussion(data: any = {}) {
    return this._api.post('travel-messaging/list-discussion', data);
  }

  viewedDiscussion(data: any = {}) {
    return this._api.post('travel-messaging/set-discussion-viewed', data);
  }

  removeMessage(data: any = {}) {
    return this._api.post('travel-messaging/remove-message', data);
  }

  listMessage(data: any = {}) {
    return this._api.post('travel-messaging/list-message', data);
  }
  
  muteUser(data: any = {}) {
    return this._api.post('messaging-discussion/mute-user', data);
  }

  unmuteUser(data: any = {}) {
    return this._api.post('messaging-discussion/unmute-user', data);
  }

  sendMessage(data: any) {
    return this._api.post('travel-messaging/send-message', data);
  }

  updateMessage(data: any) {
    return this._api.post('travel-messaging/update-message', data);
  }

  pull(data: any) {
    return this._api.post('travel-messaging/pull', data, { edge: true });
  }
}
